var map = {
	"./bookmark_deascuola.svg": "4871",
	"./bookmark_formazione.svg": "2933",
	"./bookmark_za.svg": "5824",
	"./bookmark_zm.svg": "eae2",
	"./bookmark_zs.svg": "94bd",
	"./deaflix/arrow_dx.svg": "75e5",
	"./deaflix/arrow_dx_outline.svg": "3904",
	"./deaflix/bookmark.svg": "43cd",
	"./deaflix/bookmark_active.svg": "8156",
	"./deaflix/bookmark_outline.svg": "eec2",
	"./deaflix/bookmark_selected.svg": "6268",
	"./deaflix/close_outline.svg": "0e54",
	"./deaflix/demo_box.svg": "88cc",
	"./deaflix/export_outline.svg": "5d95",
	"./deaflix/eye_color.svg": "c14c",
	"./deaflix/eye_colored.svg": "2367",
	"./deaflix/lock_outline.svg": "06eb",
	"./deaflix/logo_Deaflix.svg": "c423",
	"./deaflix/search_active.svg": "579c",
	"./deaflix/search_outline.svg": "f2c2",
	"./deaflix/share_outline.svg": "eb81",
	"./deaflix/subjects.svg": "f39c",
	"./deaflix/topics.svg": "640f",
	"./deaflix/topics_all.svg": "fc18",
	"./deprecated.svg": "c726",
	"./evidenza_neg.svg": "1567",
	"./evidenza_pos.svg": "a707",
	"./formazione/dea-formazione-ico-0-6-anni.svg": "c2d6",
	"./formazione/dea-formazione-ico-ambienti-di-apprendimento.svg": "5c12",
	"./formazione/dea-formazione-ico-arte.svg": "3392",
	"./formazione/dea-formazione-ico-asl-orientamento.svg": "9f2e",
	"./formazione/dea-formazione-ico-autonomia-valutazione.svg": "0259",
	"./formazione/dea-formazione-ico-benessere-a-scuola.svg": "20f7",
	"./formazione/dea-formazione-ico-clil.svg": "b666",
	"./formazione/dea-formazione-ico-competenze.svg": "33f9",
	"./formazione/dea-formazione-ico-contrasto-dispersione-scolastica.svg": "08c6",
	"./formazione/dea-formazione-ico-ddi.svg": "8553",
	"./formazione/dea-formazione-ico-didattica-digitale.svg": "2034",
	"./formazione/dea-formazione-ico-didattica-inclusiva.svg": "2e17",
	"./formazione/dea-formazione-ico-ed-civica.svg": "bc5f",
	"./formazione/dea-formazione-ico-fisica.svg": "b2f4",
	"./formazione/dea-formazione-ico-francese.svg": "118e",
	"./formazione/dea-formazione-ico-inglese.svg": "5ff1",
	"./formazione/dea-formazione-ico-innovazione-scolastica.svg": "56d7",
	"./formazione/dea-formazione-ico-italiano.svg": "a028",
	"./formazione/dea-formazione-ico-la-scuola-e-2023.svg": "9cbf",
	"./formazione/dea-formazione-ico-la-scuola-e.svg": "48d2",
	"./formazione/dea-formazione-ico-letteratura.svg": "04f4",
	"./formazione/dea-formazione-ico-matematica.svg": "09bd",
	"./formazione/dea-formazione-ico-mediazione-didattica.svg": "25ce",
	"./formazione/dea-formazione-ico-musica.svg": "d802",
	"./formazione/dea-formazione-ico-parita-di-genere.svg": "8889",
	"./formazione/dea-formazione-ico-pnnr.svg": "629b",
	"./formazione/dea-formazione-ico-religione.svg": "520e",
	"./formazione/dea-formazione-ico-scienze-motorie.svg": "44b1",
	"./formazione/dea-formazione-ico-scienze-umane.svg": "33e4",
	"./formazione/dea-formazione-ico-scienze.svg": "967d",
	"./formazione/dea-formazione-ico-spagnolo.svg": "c7df",
	"./formazione/dea-formazione-ico-stem.svg": "ebea",
	"./formazione/dea-formazione-ico-storia-geografia.svg": "77e3",
	"./formazione/dea-formazione-ico-tecnologia.svg": "ca61",
	"./formazione/downloadable_material.svg": "f008",
	"./formazione/educational_activities.svg": "21a2",
	"./formazione/forum.svg": "fe4b",
	"./formazione/tutorial.svg": "a904",
	"./formazione/video_lessons.svg": "4dc5",
	"./formazione/webinar.svg": "fdc5",
	"./griglia.svg": "1dbf",
	"./lista.svg": "a11f",
	"./messages/AP_ico_alert.svg": "44ab",
	"./messages/AP_ico_info.svg": "451c",
	"./messages/AP_ico_question.svg": "3d3d",
	"./notifica-libro.svg": "9411",
	"./prototype.svg": "59a9",
	"./ready.svg": "e951",
	"./review.svg": "08d0",
	"./zonamatematica/ZonaMate_icone_Contenuto.svg": "43f5",
	"./zonamatematica/ZonaMate_icone_Contenuto_bianca.svg": "51dd",
	"./zonamatematica/ZonaMate_icone_GeoGebra.svg": "0cf0",
	"./zonamatematica/ZonaMate_icone_GeoGebra_bianca.svg": "f7af",
	"./zonamatematica/ZonaMate_icone_Metodo.svg": "433c",
	"./zonamatematica/ZonaMate_icone_Metodo_bianca.svg": "4ff2",
	"./zonamatematica/ZonaMate_icone_Obiettivi.svg": "dcbe",
	"./zonamatematica/ZonaMate_icone_Obiettivi_bianca.svg": "8b59",
	"./zonamusica/zMu_ico_ascolto.svg": "3629"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ce87";